import { CloudDeliveryPromiseType } from "@omni/types/api/product/cloud/shared/enums/deliveryPromiseType.enum";
import { CloudStockLevel } from "@omni/types/api/product/cloud/shared/enums/stockLevel.enum";
import { CloudProductAvailability } from "@omni/types/api/store/cloud/shared/productAvailability.model";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { determineDeliveryTimeTranslationKey } from "@/utils/deliveryPromise";

const getStockStyles = (productAvailability?: CloudProductAvailability) => {
    if (
        productAvailability?.deliveryPromiseType ===
        CloudDeliveryPromiseType.AvailableForS2S
    ) {
        return "s2s";
    } else if (
        !productAvailability?.realTimeStockAvailable &&
        productAvailability?.stockLevel === CloudStockLevel.LowStock
    ) {
        return "lowStock";
    } else if (
        (!productAvailability?.realTimeStockAvailable &&
            productAvailability?.stockLevel === CloudStockLevel.NoStock) ||
        (!productAvailability?.realTimeStockAvailable &&
            productAvailability?.stockLevel === null) ||
        (productAvailability?.realTimeStockAvailable &&
            productAvailability?.realTimeStock! <= 0)
    ) {
        return "noStock";
    } else {
        return "available";
    }
};

type Props = {
    productAvailability?: CloudProductAvailability;
};

const Stock = ({ productAvailability }: Props) => {
    const { t } = useGranite();

    const tk = determineDeliveryTimeTranslationKey({
        deliveryPromiseType: productAvailability?.deliveryPromiseType,
        stockLevel: productAvailability?.stockLevel,
        realTimeStockAvailable: productAvailability?.realTimeStockAvailable,
        realTimeStock: productAvailability?.realTimeStock,
        deliveryTime: productAvailability?.deliveryTime
    });

    const stock = getStockStyles(productAvailability);

    const deliveryTimeUnitTk = `product.deliveryPromise.timeUnits.${productAvailability?.deliveryTimeUnit}`;

    return (
        <span
            className={cn({
                "tw:text-success": stock === "available",
                "tw:text-warning": stock === "lowStock",
                "tw:text-danger": stock === "noStock"
            })}
        >
            <i
                className={cn(
                    "las",
                    {
                        "la-check": ["available", "s2s", "lowStock"].includes(
                            stock
                        ),
                        "la-times": stock === "noStock"
                    },
                    "tw:mr-1"
                )}
            />
            {tk &&
                t(
                    tk,
                    productAvailability?.deliveryTime,
                    t(deliveryTimeUnitTk),
                    productAvailability?.realTimeStock
                )}
        </span>
    );
};

export default Stock;
